import React, { useState, useEffect } from "react";
import SearchIcon from "../../../public/static/images/svg/search.svg";

type CustomModalProps = {
  hideModal: any;
  listData: Array<any>;
  inputPlaceholder: string;
  inputId: string;
  hideInputRadioIcon?: boolean;
  hideInputLocationIcon?: boolean;
  searchOnKeyUp?: any;
  getInputRadioValue: any;
  modalTitle?: string;
};

const CustomModal = ({
  hideModal,
  listData,
  inputPlaceholder,
  inputId,
  hideInputRadioIcon,
  hideInputLocationIcon,
  searchOnKeyUp,
  getInputRadioValue,
  modalTitle
}: CustomModalProps) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const body = document.body,
      html = document.documentElement;
    const calcHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    setHeight(calcHeight);
  }, []);

  return (
    <div className={"modal-wrapper"}>
      <div className="modal-body modal-body--mobile-slide">
        <button className="close-btn" onClick={hideModal}>
          X
        </button>
        <div className="modal-header">
          <h3>{modalTitle}</h3>
        </div>
        <div className="header-modal-list-purpose border-bottom">
          <React.Fragment>
            <input
              placeholder={inputPlaceholder}
              type="text"
              autoComplete="off"
              id={inputId}
              className="input-search"
              maxLength={20}
              onKeyUp={searchOnKeyUp}
            />
            <img className="search-logo" src={SearchIcon} />
          </React.Fragment>
        </div>

        <div className="list-data">
          {listData && listData.length <= 0 && <label>Data tidak ditemukan</label>}
          {listData && listData.length > 0 &&
            listData.map((i, k) => {
              return (
                <div className="input-radio-button border-bottom" key={k}>
                  <img
                    className={`input-icon-location ${
                      hideInputLocationIcon ? "hidden" : ""
                      }`}
                    alt="icon-location"
                  />
                  <label htmlFor={i}>{i}</label>
                  <input
                    type="radio"
                    id={i}
                    name={inputId}
                    value={i}
                    className={`radio-button ${
                      hideInputRadioIcon ? "hidden" : ""
                      }`}
                    onClick={getInputRadioValue}
                  />
                </div>
              );
            })}
        </div>
      </div>
      <style jsx>{`
        .search-logo {
          position: absolute;
          margin-left: 5px;
        }

        .modal-header {
          margin: 15px 0px 15px 0px;
        }

        .radio-button {
          visibility: hidden;
        }

        .input-search {
          font-size: 16px;
          margin-top: 6px;
          margin-left: 32px;
        }

        input[type="radio"]:after {
          width: 22px;
          height: 22px;
          border-radius: 15px;
          top: -50%;
          left: 12px;
          position: relative;
          background-color: var(--color-gray-lighter);
          content: "";
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
        }

        input[type="radio"]:checked :after {
          width: 22px;
          height: 22px;
          border-radius: 15px;
          top: -50%;
          left: 12px;
          position: relative;
          background-color: var(--color-green);
          content: "";
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
        }

        .input-radio-button {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          min-height: 52px;
        }

        .border-bottom {
          border-bottom: 1px solid var(--color-gray-lightest);
        }

        .input-radio-button > input {
          width: 10%;
        }

        .input-radio-button > label {
          font-size: 14px;
          font-weight: bold;
          width: 80%;
        }

        .input-icon-location {
          width: 20%;
          height: 26px;
        }

        label {
          font-size: 12px;
          margin: 4px 8px;
          font-weight: bold;
        }

        input,
        select {
          margin: 4px 8px;
        }

        input:focus,
        select:focus {
          outline: none;
        }

        input,
        select {
          border: none;
          background: none;
          width: 100%;
        }

        .hidden {
          display: none;
        }

        .modal-wrapper {
          position: fixed;
          width: 100%;
          // height: ${height}px; uncomment when necessary
          z-index: 20;
          background-color: rgb(64, 64, 64, 0.6);
          color: black;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .modal-body {
          background-color: white;
          border-radius: 10px;
          min-width: 300px;
          min-height: 330px;
          height: 500px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          padding: 20px;
          display: flex;
          flex-direction: column;
        }

        .header-modal-list-purpose {
          width: 100%;
          min-height: 45px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #f4f4f4;
          color: #a9a9a9;
          border-radius: 16px;
        }

        .list-data {
          width: 100%;
          overflow: scroll;
        }

        .modal-illustration {
          text-align: center;
        }

        .modal-illustration img {
          width: 80%;
        }

        .modal-title {
          font-weight: bold;
          text-align: center;
          margin: 10px 0 20px;
        }

        .modal-subtitle {
          color: #676767;
          text-align: center;
          width: 310px;
          line-height: 24px;
        }

        .modal-action {
          display: flex;
          justify-content: space-between;
          width: 100%;
          margin-top: 30px;
        }

        .modal-action .button {
          flex: 1;
        }

        .modal-action .button:not(:last-child) {
          margin-right: 30px;
        }

        .close-btn {
          position: absolute;
          border-radius: 50%;
          width: 35px;
          height: 35px;
          right: 20px;
          top: -15px;
          font-size: 16px;
        }

        @media only screen and (max-width: 600px) {
          .input-radio-button > input {
            width: 5%;
          }

          .input-radio-button > label {
            font-size: 14px;
            font-weight: bold;
            width: 95%;
          }

          .modal-body {
            margin: 0;
            min-width: 300px;
            width: 300px;
            min-height: 300px;
            height: 400px;
            padding: 20px 0 0;
            justify-content: flex-start;
          }

          .modal-subtitle {
            font-size: 13px;
            width: auto;
            padding: 10px;
          }

          .modal-action .button:not(:last-child) {
            margin-right: 20px;
          }

          .modal-action .button {
            border-radius: 0;
            padding: 10px 20px;
          }

          .modal-body--mobile-slide {
            border-radius: 0;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            width: calc(100% - 40px);
            bottom: 0;
            top: unset;
            transform: initial;
            left: 0;
            padding: 20px;
            margin: 0;
            position: fixed;
            min-height: 300px;
            transition: all 1.5s;
            min-width: 260px;
          }

          .modal-body--mobile-slide--hide {
            bottom: -100%;
          }

          .modal-body--mobile-slide .modal-action .button {
            border-radius: 10px;
          }

          .radio-button {
            visibility: hidden;
          }

          input[type="radio"]:after {
            width: 20px;
            height: 20px;
            left: -5px;
          }

          input[type="radio"]:checked:after {
            width: 20px;
            height: 20px;
            left: -5px;
          }
        }
      `}</style>
    </div>
  );
};

export default CustomModal;
